
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { LoginLayoutService } from '@core/services/login-layout.service';
import { Subject } from 'rxjs';

import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-login-layout',
  standalone: true,
  templateUrl: './login-layout.component.html',
  styleUrl: './login-layout.component.scss',
  imports: [RouterModule, MatIconModule],
})
export class LoginLayoutComponent {
  router = inject(Router);
  logoimage = 'assets/Loginlogo.svg';
  onDestroy$: Subject<boolean> = new Subject();
  public fullScreen: boolean = false;
  constructor(
    public loginLayoutService: LoginLayoutService
  ) {}

  navigateSingup(): void {
    this.router.navigate(['/auth/signup']);
  }
}
